import React, { Component, Fragment } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import isAuthenticated from '../common/util/authWrapper';
import Navbar from '../menu/navbar/Navbar';
import Login from '../menu/login/Login';
import NotFound from '../menu/login/NotFound';
import Register1 from '../menu/login/Register1';
import Register2 from '../menu/login/Register2';
import Register3 from '../menu/login/Register3';
import AuthDashboard from '../menu/login/AuthDashboard';
// Student Menu
import Dashboard from '../menu/students-menu/dashboard/Index';

// import Pembelajaran from '../menu/students-menu/pembelajaran/Index';
// import Accounts from '../menu/students-menu/account-statement/Index';
// import AccountsDetail from '../menu/students-menu/account-statement/View';
import ModalManager from '../menu/modals/ModalManager';
import './App.css';
import LoadingPage from '../common/layout/LoadingPage';



const Profile = React.lazy(() => import('../menu/students-menu/profil/Index'));
const Absensi = React.lazy(() => import('../menu/students-menu/presensi/Index'));
const Jadwal = React.lazy(() => import('../menu/students-menu/jadwal/Index'));
const MateriView = React.lazy(() => import('../menu/students-menu/pembelajaran/ViewMateri'));
const TugasView = React.lazy(() => import('../menu/students-menu/pembelajaran/ViewTugas'));
const LatihanView = React.lazy(() => import('../menu/students-menu/pembelajaran/ViewLatihan'));
const LatihanResult = React.lazy(() => import('../menu/students-menu/pembelajaran/ViewLatihanResult'));
const LatihanReview = React.lazy(() => import('../menu/students-menu/pembelajaran/ViewLatihanReview'));
const TesView = React.lazy(() => import('../menu/students-menu/pembelajaran/ViewTes'));
const Rapormid = React.lazy(() => import('../menu/students-menu/rapor-mid/Index'));
const RapormidDetail = React.lazy(() => import('../menu/students-menu/rapor-mid/View'));
const Raporsem = React.lazy(() => import('../menu/students-menu/rapor-sem/Index'));
const RaporsemDetail = React.lazy(() => import('../menu/students-menu/rapor-sem/View'));
const HasilTestPsikologis = React.lazy(() => import('../menu/students-menu/hasil-test-psikologis/Index'));
const Raporkolab = React.lazy(() => import('../menu/students-menu/rapor-kolab/Index'));
const Progressreport = React.lazy(() => import('../menu/students-menu/progress-report/Index'));
const ProgressreportDetail = React.lazy(() => import('../menu/students-menu/progress-report/View'));
const Raporsemtk = React.lazy(() => import('../menu/students-menu/rapor-sem-tk/Index'));
const RaporsemtkDetail = React.lazy(() => import('../menu/students-menu/rapor-sem-tk/View'));
// Used Accounts2
const Accounts2 = React.lazy(() => import('../menu/students-menu/account-statement/Index2'));
const AccountsDetail2 = React.lazy(() => import('../menu/students-menu/account-statement/View2'));
// End
// import Accounts3 from '../menu/students-menu/account-statement/Index3';
// import AccountsDetail3 from '../menu/students-menu/account-statement/View3';
// import Accounts4 from '../menu/students-menu/account-statement/Index4';
// import AccountsDetail4 from '../menu/students-menu/account-statement/View4';
const Agenda = React.lazy(() => import('../menu/students-menu/agenda/Index'));
const Kalender = React.lazy(() => import('../menu/students-menu/kalender-akademik/Index'));
const Pesan = React.lazy(() => import('../menu/students-menu/pesan-pribadi/Index'));
const PengaturanAkun = React.lazy(() => import('../menu/students-menu/pengaturan-akun/Index'));
// Student Menu End
const Test = React.lazy(() => import('../menu/tests/Index'));
const PrintPage = React.lazy(() => import('../menu/tests/PrintPage'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You can log error info here
    console.error('App Error:', error, info);
  }

  handleSessionStorageRemove(unamePass) {
    if (unamePass) {
      window.ReactNativeWebView.postMessage('logout');
    } else {
      sessionStorage.clear();
      window.location.reload();
    }
  }

  render() {
    let unamePass = localStorage.getItem('unamePass');
    if (this.state.hasError) {
      return (
        <div
          style={{
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: -100,
          }}
        >
          <div>
            <h1 style={{ fontSize: 30, color: '#2863eb' }}>
              Something went wrong.
            </h1>
            <p
              style={{
                fontWeight: 500,
              }}
            >
              Sorry, we can't display the page. Something's missing.
            </p>
            <pre
              style={{
                display: 'flex',
                flexDirection: 'column',
                whiteSpace: 'pre-wrap',
                border: '1px solid #2863eb',
                margin: '20px 10px',
                borderRadius: 5,
                maxWidth: 600,
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Note: Please contact admin for further support.
              </p>
              <details>
                <summary style={{ cursor: 'pointer', userSelect: 'none' }}>
                  Details Error
                </summary>
                {this.state.error?.toString()}
              </details>
            </pre>
            <button
              style={{
                background: '#2863eb',
                border: '1px solid #2863eb',
                borderRadius: 50,
                boxSizing: 'border-box',
                color: '#FFFFFF',
                cursor: 'pointer',
                display: 'inline-block',
                fontSize: 16,
                height: 40,
                padding: '3px 14px',
                textAlign: 'center',
              }}
              onClick={() => this.handleSessionStorageRemove(unamePass)}
            >
              Reset App
            </button>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <ModalManager />
        <Fragment>
          <Navbar />
          <React.Suspense fallback={<LoadingPage />}>
            <Switch key={this.props.location.key}>
              <Route exact path='/' component={Login} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/register' component={Register1} />
              <Route exact path='/register-2' component={Register2} />
              <Route exact path='/register-3' component={Register3} />
              <Route exact path='/authdashboard' component={AuthDashboard} />
              {/* Students Menu */}
              <Route
                exact
                path='/dashboard'
                component={isAuthenticated(Dashboard)}
              />
              <Route exact path='/profil' component={isAuthenticated(Profile)} />
              <Route
                exact
                path='/absensi'
                component={isAuthenticated(Absensi)}
              />
              <Route
                exact
                path='/pembelajaran/materi/:id'
                component={isAuthenticated(MateriView)}
              />
              <Route
                exact
                path='/pembelajaran/tugas/:id'
                component={isAuthenticated(TugasView)}
              />
              <Route
                exact
                path='/pembelajaran/latihan/:id'
                component={isAuthenticated(LatihanView)}
              />
              <Route
                exact
                path='/pembelajaran/latihan/result/:id'
                component={isAuthenticated(LatihanResult)}
              />
              <Route
                exact
                path='/pembelajaran/latihan/review/:id'
                component={isAuthenticated(LatihanReview)}
              />
              <Route
                exact
                path='/pembelajaran/tes/:id'
                component={isAuthenticated(TesView)}
              />
              {/* <Route
              path='/pembelajaran'
              component={isAuthenticated(Pembelajaran)}
            /> */}
              <Route exact path='/jadwal' component={isAuthenticated(Jadwal)} />
              <Route
                exact
                path='/rapor-mid'
                component={isAuthenticated(Rapormid)}
              />
              <Route
                exact
                path='/rapor-mid/:id'
                component={isAuthenticated(RapormidDetail)}
              />
              <Route
                exact
                path='/rapor-sem'
                component={isAuthenticated(Raporsem)}
              />
              <Route
                exact
                path='/rapor-sem/:id'
                component={isAuthenticated(RaporsemDetail)}
              />
              <Route
                exact
                path='/rapor-kolab'
                component={isAuthenticated(Raporkolab)}
              />
              <Route
                exact
                path='/hasil-test-psikologis'
                component={isAuthenticated(HasilTestPsikologis)}
              />
              <Route
                exact
                path='/progress-report'
                component={isAuthenticated(Progressreport)}
              />
              <Route
                exact
                path='/progress-report/:id'
                component={isAuthenticated(ProgressreportDetail)}
              />
              <Route
                exact
                path='/rapor-sem-tk'
                component={isAuthenticated(Raporsemtk)}
              />
              <Route
                exact
                path='/rapor-sem-tk/:id'
                component={isAuthenticated(RaporsemtkDetail)}
              />
              <Route
                exact
                path='/account-statement'
                component={isAuthenticated(Accounts2)}
              />
              <Route
                exact
                path='/account-statement/:id'
                component={isAuthenticated(AccountsDetail2)}
              />
              {/* <Route
                exact
                path='/account-statement4'
                component={isAuthenticated(Accounts4)}
              />
              <Route
                exact
                path='/account-statement4/:id'
                component={isAuthenticated(AccountsDetail4)}
              /> */}
              <Route
                exact
                path='/account-statement2'
                component={isAuthenticated(Accounts2)}
              />
              <Route
                exact
                path='/account-statement2/:id'
                component={isAuthenticated(AccountsDetail2)}
              />
              {/* <Route
                exact
                path='/account-statement3'
                component={isAuthenticated(Accounts3)}
              />
              <Route
                exact
                path='/account-statement3/:id'
                component={isAuthenticated(AccountsDetail3)}
              /> */}
              <Route exact path='/agenda' component={isAuthenticated(Agenda)} />
              <Route
                exact
                path='/kalender-akademik'
                component={isAuthenticated(Kalender)}
              />
              <Route
                exact
                path='/pesan-pribadi'
                component={isAuthenticated(Pesan)}
              />
              <Route
                exact
                path='/pengaturan-akun'
                component={isAuthenticated(PengaturanAkun)}
              />
              {/* Students Menu End */}
              <Route path='/test' component={Test} />
              <Route path='/test/printpage' component={PrintPage} />
              <Route path='/*' component={NotFound} />
            </Switch>
          </React.Suspense>
        </Fragment>
      </Fragment>
    );
  }
}

export default withRouter(App);
